import { z } from "zod";
import { OffboardingRequestSchema } from "./offboarding-request.schema.ts";

export const OffboardingListSchema = z.array(OffboardingRequestSchema);
export type OffboardingListItem = z.infer<typeof OffboardingRequestSchema>;
